const SESSION_KEY = `${process.env.VUE_APP_APP_NAME || 'flowit'}-session`;
const REFRESH_TOKEN_KEY = `${process.env.VUE_APP_APP_NAME || 'flowit'}-refresh-token`;
const TOKEN_EXPIRES_KEY = `${process.env.VUE_APP_APP_NAME || 'flowit'}-token-expires`;

export const set = token => {
  window.sessionStorage.setItem(SESSION_KEY, token);
};

export const setTokenData = (tokenData) => {
  window.sessionStorage.setItem(SESSION_KEY, tokenData.token);
  if (tokenData.refresh_token) {
    window.sessionStorage.setItem(REFRESH_TOKEN_KEY, tokenData.refresh_token);
  }
  if (tokenData.expires_at) {
    window.sessionStorage.setItem(TOKEN_EXPIRES_KEY, tokenData.expires_at);
  }
};

export const get = () => {
  if (navigator.cookieEnabled) {
    return window.sessionStorage.getItem(SESSION_KEY);
  }
  return false;
};

export const getRefreshToken = () => {
  if (navigator.cookieEnabled) {
    return window.sessionStorage.getItem(REFRESH_TOKEN_KEY);
  }
  return false;
};

export const getExpiresAt = () => {
  if (navigator.cookieEnabled) {
    return window.sessionStorage.getItem(TOKEN_EXPIRES_KEY);
  }
  return false;
};

export const isExpired = () => {
  const expiresAt = getExpiresAt();
  if (!expiresAt) {
    return false; // Se não tem data de expiração, considera válido
  }
  
  try {
    const expirationDate = new Date(expiresAt);
    const now = new Date();
    return now >= expirationDate;
  } catch (e) {
    console.warn('Error parsing token expiration date:', e);
    return false;
  }
};

export const exists = () => {
  const token = get();
  return token && token !== 'undefined' && !isExpired();
};

export const destroy = () => {
  window.sessionStorage.removeItem(SESSION_KEY);
  window.sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  window.sessionStorage.removeItem(TOKEN_EXPIRES_KEY);
};
